/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Orders_EmptyInputs */

const en_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No orders yet.`)
};

const es_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay pedidos.`)
};

const fr_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune commande pour le moment.`)
};

const de_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bestellungen.`)
};

const ja_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ注文はありません。`)
};

const zh_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无订单。`)
};

const ar_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد طلبات بعد.`)
};

const id_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pesanan.`)
};

const it_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun ordine.`)
};

const ru_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет заказов.`)
};

const pt_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum pedido ainda.`)
};

const ko_seller_orders_empty = /** @type {(inputs: Seller_Orders_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 주문이 없습니다.`)
};

/**
* | output |
* | --- |
* | "No orders yet." |
*
* @param {Seller_Orders_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_orders_empty = /** @type {((inputs?: Seller_Orders_EmptyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Orders_EmptyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_orders_empty(inputs)
	if (locale === "es") return es_seller_orders_empty(inputs)
	if (locale === "fr") return fr_seller_orders_empty(inputs)
	if (locale === "de") return de_seller_orders_empty(inputs)
	if (locale === "ja") return ja_seller_orders_empty(inputs)
	if (locale === "zh") return zh_seller_orders_empty(inputs)
	if (locale === "ar") return ar_seller_orders_empty(inputs)
	if (locale === "id") return id_seller_orders_empty(inputs)
	if (locale === "it") return it_seller_orders_empty(inputs)
	if (locale === "ru") return ru_seller_orders_empty(inputs)
	if (locale === "pt") return pt_seller_orders_empty(inputs)
	return ko_seller_orders_empty(inputs)
});